<template lang="html">
    <div class="page" id="accept">
        <header class="pageHeader">
            <div class="pageHeaderIntro">
                <h1>Hi!</h1>
                <p data-cy="welcome">You've been invited to Lesson Pro</p>
                <img class="icon" src="~@/assets/icons/headers/profile.svg" />
            </div>
        </header>

        <div id="scroller">
            <span class="info">Enter your details below to join Lesson Pro</span>

            <form class="form3" @submit.prevent="acceptInvite">
                <div class="formGroup">
                    <label>Password</label>
                    <password-input v-model="form.password" />
                    <has-error :form="form" field="password"></has-error>
                </div>
                <div class="formGroup">
                    <label>Confirm password</label>
                    <password-input v-model="form.password_confirmation" />
                    <has-error :form="form" field="password_confirmation"></has-error>
                </div>
                <div class="formGroup">
                    <label>Token</label>
                    <input type="text" v-model="form.token" />
                </div>

                <button :disabled="form.busy" class="button" type="submit" name="button">
                    {{ form.busy ? "Please wait..." : "Join Lesson Pro" }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import PasswordInput from "@/components/App/password-input";
import { Form, HasError } from "vform";
import Cookie from "js-cookie";
export default {
    name: "accept-invite",
    components: {
        PasswordInput,
        HasError,
    },
    created() {
        this.form.token = this.$route.query.token;
    },
    data() {
        return {
            form: new Form({
                token: "",
                password: "",
                password_confirmation: "",
            }),
        };
    },
    methods: {
        acceptInvite() {
            this.form.post("/pending_player/accept").then((response) => {
                Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, response.data.api_token);
                this.$store.state.user = response.data;
                this.$router.push({ name: "Home" });
            });
        },
    },
};
</script>

<style lang="scss">
#accept {
    .passwordInput .icon {
        position: absolute;
        right: 17px;
        top: 17px;
    }
}
</style>
